class ProductImageScroll extends window.BAO.CustomElement() {
  connectedCallback () {
    this.addEventListener('scroll', this.handleImagesScroll.bind(this), {
      passive: true,
    })
  }

  handleImagesScroll (event) {
    const imagesEl = event?.target
    const selectedIndex =
      imagesEl?.scrollLeft <= imagesEl?.offsetWidth / 2 ? 0 : 1

    this.imageControlEls.forEach((imageControlEl, index) => {
      imageControlEl.setAttribute(
        'aria-selected',
        Number(index) === selectedIndex,
      )
    })
  }

  get imageControlEls () {
    return this.querySelectorAll(
      '[data-product-image-scroll-el="image-control"]',
    )
  }
}

if (!customElements.get('product-image-scroll')) {
  customElements.define('product-image-scroll', ProductImageScroll)
}
